import { render } from "./ProProdutosView.vue?vue&type=template&id=a2dc4002&scoped=true"
import script from "./ProProdutosView.vue?vue&type=script&lang=js"
export * from "./ProProdutosView.vue?vue&type=script&lang=js"

import "./ProProdutosView.vue?vue&type=style&index=0&id=a2dc4002&scoped=true&lang=css"

import exportComponent from "C:\\SGCAD25\\Induscapas\\FrontBack\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2dc4002"]])

export default __exports__